import { useRef } from 'react';
import { Mesh } from 'three';

export function Road() {
  const roadRef = useRef<Mesh>(null);

  return (
    <group>
      {/* Main road surface */}
      <mesh receiveShadow position={[0, -0.1, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[100, 20]} />
        <meshStandardMaterial color="#333333" roughness={0.8} metalness={0.2} />
      </mesh>

      {/* Lane markings - four lanes */}
      {[-5, 0, 5].map((x, i) => (
        <mesh key={i} position={[0, 0.01, x]} rotation={[-Math.PI / 2, 0, 0]}>
          <planeGeometry args={[100, 0.2]} />
          <meshStandardMaterial color="#FFFFFF" roughness={0.3} />
        </mesh>
      ))}

      {/* Crosswalk stripes */}
      {Array.from({ length: 8 }, (_, i) => (
        <mesh 
          key={`crosswalk-${i}`} 
          position={[0, 0.02, -8.75 + (i * 2.5)]} 
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <planeGeometry args={[8, 2]} />
          <meshStandardMaterial color="#FFFFFF" roughness={0.3} />
        </mesh>
      ))}

      {/* Sidewalks */}
      {[-14.5, 14.5].map((z, i) => (
        <mesh key={i} position={[0, 0, z]} rotation={[-Math.PI / 2, 0, 0]}>
          <planeGeometry args={[100, 9]} />
          <meshStandardMaterial color="#999999" roughness={0.7} />
        </mesh>
      ))}

      {/* Road edges */}
      {[-10, 10].map((z, i) => (
        <mesh key={i} position={[0, 0.01, z]} rotation={[-Math.PI / 2, 0, 0]}>
          <planeGeometry args={[100, 0.3]} />
          <meshStandardMaterial color="#FFFFFF" roughness={0.3} />
        </mesh>
      ))}
    </group>
  );
}